export default "__VITE_ASSET__50876953__"